import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const StyleHeading = styled.h4<any>`
  font-size: 16px;
  color: ${(props: any) => props.theme.colors[props.tc]};
  font-weight: 400;
  display: flex;
  align-items: center;
  column-gap: 5px;
`

export const StyleLink = styled(Link)`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.secondary};
`
